import React from "react";
import TotalCartTable from "./components/TotalCartTable";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import Cart from "./components/Cart";
import useCart from "../../hooks/useCart";
import { useAuth } from "../../hooks/useAuth";
import { formatCurrency } from "../../util/formatters";

const CartLayout = () => {

  const {
    cart,
    totalValue,
  } = useCart();
  const { userInfo } = useAuth();
  const buyingLimitTotal = userInfo?.user_buying_limit ?? 0;
  const buyingLimitAvailable = userInfo?.user_buying_limit_available ?? 0;
  const buyingLimitUsedLast30Days =
    userInfo?.user_buying_limit_used_last_30_days ?? 0;

  const isBuying = cart.length > 0;
  const isPurchaseDisabled = () =>
    totalValue() > buyingLimitAvailable;

  return (
    <>
      <SEO 
        title="Carrinho de Compras | Grupo Terra"
        description="Revise seus produtos no carrinho de compras. Finalize seu pedido com segurança."
        keywords="carrinho, compras, pedido"
      />
      <div className="liton__shoping-cart-area mb-120">
        <div className="container">
        <Cart />
        <div className="row justify-content-end">
          <div className="shoping-cart-total mt-50 justify-content-end">
            <TotalCartTable />
            {isBuying && (
              <>
                <div
                  style={{
                    marginTop: "12px",
                    paddingTop: "8px",
                    borderTop: "1px solid #e5eaee",
                  }}
                >
                  <strong
                    style={{ fontSize: "13px", lineHeight: 1.4, color: "#6c757d" }}
                  >
                    Limites:{" "}
                    <span style={{ color: "var(--bs-success, #198754)" }}>
                      Total: {formatCurrency(buyingLimitTotal)}
                    </span>{" "}
                    |{" "}
                    <span
                      style={{
                        color:
                          buyingLimitAvailable > 0
                            ? "var(--bs-success, #198754)"
                            : "var(--ltn__secondary-color, #dc3545)",
                      }}
                    >
                      Disponivel: {formatCurrency(buyingLimitAvailable)}
                    </span>{" "}
                    |{" "}
                    <span style={{ color: "var(--ltn__secondary-color, #dc3545)" }}>
                      Usado (30 dias): {formatCurrency(buyingLimitUsedLast30Days)}
                    </span>
                  </strong>
                </div>
                {isPurchaseDisabled() && (
                  <div className="mt-3">
                    <strong>
                      <span className="text-danger">
                        Valor total do carrinho ultrapassou o limite de
                        compra!
                      </span>
                    </strong>
                  </div>
                )}
                <div className="btn-wrapper text-right go-top">
                  {isPurchaseDisabled() ? (
                    <button
                      type="button"
                      disabled
                      className="theme-btn-1-opposite btn w-100"
                      title="Finalizar compra (indisponível — limite excedido)"
                    >
                      Finalizar compra
                    </button>
                  ) : (
                    <Link
                      to="/finalizar-pedido"
                      className="theme-btn-1 btn btn-effect-1 w-100"
                      title="Finalizar compra"
                    >
                      Finalizar compra
                    </Link>
                  )}
                </div>
              </>
            )}

          </div>
        </div>
      </div>
    </div>
    </>
  );
};
export default CartLayout;
